import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import { Box, Dialog, InputBase, Typography, ListItem, CircularProgress, IconButton } from '@material-ui/core';
import { Close, Search, Add, } from '@material-ui/icons'
import { useDataProvider, useTranslate } from 'react-admin';
import SelectBox from '../CustomizedUIs/CustomSelectBox'
import { useSelector } from 'react-redux';
import { darkTheme, lightTheme } from '../layout/themes';
import { makeStyles } from '@material-ui/core/styles'
import CustomPoper from '../CustomizedUIs/CustomPoper'
import IconRadiusButton from '../CustomizedUIs/IconRadiusButton'
import colors from '../CustomizedUIs/Colors'
import { red, pink } from '@material-ui/core/colors';
import CustomTextFiled from '../CustomizedUIs/CustomTextFiled'
import CloseButton from '../CustomizedUIs/CloseButton';
import CreateInSelect from '../CustomizedUIs/CreateInSelect';
import TextButtons from '../CustomizedUIs/TextButton';
const bgColorError = pink['50'];
const textColorError = red['700'];

const useStyles = makeStyles(theme => ({
  input: {
    backgroundColor: 'white',
    borderRadius: '2px',
    "&:hover": {
      backgroundColor: 'white'
    }
  },
  boxBoder: {
    borderBottom: '1px solid',
    borderRight: '1px solid',
    borderBottomColor: theme.palette.grey['200'],
    borderRightColor: theme.palette.grey['200'],
  },
  underline: {
    '&::before': {
      borderBottom: '1px solid black'
    },
    '&:hover:not($disabled):before': {
      borderBottom: '1px solid black'
    }
  },
  underlineNotValue: {
    '&::before': {
      borderBottom: '1px solid ' + colors.lightBlue['200']
    },
    '&:hover:not($disabled):before': {
      borderBottom: '1px solid' + colors.lightBlue['200']
    }
  },
  focuses: {
    backgroundColor: 'white !important'
  },
  popover: {
    position: 'relative',
    marginLeft: '1em'
  },
  header: {
    zIndex: 2,
    position: 'relative',
    WebkitBoxShadow: ' 0px 5px 5px 0px rgba(0,0,0,0.2)',
    MozBoxShadow: '0px 5px 5px 0px rgba(0,0,0,0.2)',
    boxShadow: '0px 5px 5px 0px rgba(0,0,0,0.2)',
  },
  textClose: {
    fontFamily: 'UniviaPro-Bold',
    fontSize: '10px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: ' 0.4px',
    color: '#4f5064',
  },
  btnClose: {
    width: '28px',
    height: '28px',
    border: 'solid 2px #e5f1f8',
    backgroundColor: '#ffffff',
    padding: 0
  },
  titleCluster: {
    fontFamily: 'UniviaPro-Medium',
    fontSize: '18px',
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.2,
    letterSpacing: 'normal',
    color: " #4f5064",
  },
  textLabel: {
    fontFamily: 'UniviaPro',
    fontSize: '13px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.85,
    letterSpacing: '0.13px',
    color: ' #88898c',
  },
  textLableError: {
    marginBottom: 8,
    fontFamily: 'UniviaPro',
    fontSize: '13px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: '0.13px',
    color: '#eb5a4d !important',
  },
  TextValue: {
    fontFamily: 'UniviaPro',
    fontSize: '13px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.385,
    letterSpacing: '0.13px',
    color: '#4f5064',
  },
  TextSearch: {
    fontFamily: 'UniviaPro',
    fontSize: '11px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: '#88898c',
    '&::placeholder': {
      color: '#88898c',
      opacity: 1
    }

  },
  TextCreate: {
    fontFamily: 'UniviaPro-Bold',
    fontSize: '9px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.22,
    letterSpacing: ' 0.36px',
    color: '#ffffff',
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 8,

  },
  btnCreate: {
    fontFamily: 'UniviaPro-Bold',
    fontSize: '9px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.22,
    letterSpacing: '0.36px',
    color: '#237fc2',
    padding: 4

  },

  btnCreateCluster: {
    fontFamily: 'UniviaPro-Bold',
    fontSize: '11px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: '0.44px',
    color: '#ffffff',
    padding: '13px 16px 13px 16px',
    width: 85
  }
}));


const FilterInput = ({ onChangeValue, value, name, open }) => {
  const classes = useStyles();
  const theme = useSelector((state) =>
    state.theme === 'dark' ? darkTheme : lightTheme
  );

  return (

    <Box width={200} display='flex' style={{ borderRadius: '8.1px', border: ' solid 0.8px #f1f2f4', backgroundColor: "#f7f7f7" }} >
      <Search style={{ color: '#b4b5bd', size: '18px', margin: 'auto 2px auto 5px' }} />
      <InputBase
        autoFocus={open === true ? true : false}
        value={value}
        onChange={onChangeValue}
        placeholder={"Filter " + name}
        inputProps={{
          'aria-label': 'search',
          className: classes.TextSearch
        }}
        style={{ width: '180px' }}
      />
    </Box>
  )
}

const CreateClusterDialog = ({ open, handleClose, dataRecever, autoPickEnity, ...props }) => {
  const dataProvider = useDataProvider();
  const translate = useTranslate();

  const [loading, setLoading] = useState(false);

  const [data, setData] = useState(dataRecever);

  const [clusterName, setClusterName] = useState('');
  const [cluster, setCluster] = useState('');
  const [group, setGroup] = useState('');
  const [entity, setEntity] = useState('');
  const [infoPage, setInfoPage] = useState('');
  const [openClusters, setOpenClusters] = useState(false);
  const [openGroup, setOpenGroup] = useState(false);
  const [openEntity, setOpenEntity] = useState(false);
  const [disabledEntity, setdisabledEntity] = useState(false);
  const [openInfoPage, setOpenInfoPage] = useState(false);
  const [openCreateEntity, setCreateOpenEntity] = useState(false);
  const [openCreateGroup, setCreateOpenGroup] = useState(false);
  const [infopages, setInfopages] = useState([])

  const [valueNewEntity, setValueNewEntity] = useState("");
  const [valueNewGroup, setValueNewGroup] = useState("");
  const [openTooltip, setTooltip] = React.useState(false);

  const [filterCluster, setFilterCluster] = useState('');
  const [filterGroup, setFilterGroup] = useState('');
  const [filterEntity, setFilterEntity] = useState('');
  const [filterInfopage, setFilterInfopage] = useState('')
  const [channels, setChannels] = useState([])
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openPoper, setOpenPopper] = React.useState(false);
  const [error, setError] = React.useState("");


  const classes = useStyles()



  const handleClickOpenPoper = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenPopper(true);
  };

  const handleClosePoper = () => {
    setOpenPopper(false);
  };




  //event onChang Name TextField
  const onChangeName = (e) => {
    setClusterName(e.target.value)
  }
  //----


  //--Event add new Entity
  const onCreateNewEntity = (value) => {

    var temps = data
    temps.countResult.entities.unshift({
      groupCount: 0,
      name: value,
      clusters: 0
    })
    setEntity(value)
    setData(temps)
    setCreateOpenEntity(false)
    setValueNewEntity('')
    setOpenEntity(false)
  }

  const onChangNewValueEntity = (e) => {
    setValueNewEntity(e.target.value)

  }

  const clickOpenCreateEntity = () => {
    setCreateOpenEntity(true)
  }

  const handelCancelCreateEntity = () => {
    setCreateOpenEntity(false)
  }
  //-------------------------------------



  //--Event add new Group
  const onCreateNewGroup = (value) => {

    var temps = data
    temps.countResult.groups.unshift({
      clusters: 0,
      entity: '',
      name: value
    })
    setGroup({
      clusters: 0,
      entity: '',
      name: value
    })
    setdisabledEntity(false)
    setData(temps)
    setCreateOpenGroup(false)
    setValueNewGroup('')
    setOpenGroup(false)
  }

  const onChangNewValueGroup = (e) => {
    setValueNewGroup(e.target.value)
  }

  const clickOpenCreateGroup = () => {
    setCreateOpenGroup(true)
  }

  const handelCancelCreateGroup = () => {
    setCreateOpenGroup(false)
  }
  //-------------------------------------




  //event select of Cluster
  const onChangeCluster = (cluster) => {
    setCluster(cluster)
    setEntity(cluster.entity)
    setGroup({
      name: cluster.group,
      entity: cluster.entity
    })
    if (cluster.id && infopages.find(item => cluster.infopage === item.id))
      setInfoPage(infopages.find(item => cluster.infopage === item.id))
    getChannelAssgin(cluster)
    setdisabledEntity(true)
    setOpenClusters(false)
  }

  const handleClickOpenCluster = () => {
    setOpenClusters(!openClusters)
    setOpenGroup(false)
    setOpenEntity(false)
    setOpenInfoPage(false)
    setOpenPopper(false)
  }
  const onChangeFilterCluster = (e) => {
    setFilterCluster(e.target.value)
  }
  //----------------------



  //event select of Group
  const onChangeGroup = (value) => {
    setGroup(value)
    setEntity(value.entity)
    setdisabledEntity(value.entity != "")
    setOpenGroup(false)
  }

  const handleClickOpenGroup = () => {
    setOpenGroup(!openGroup)
    setOpenEntity(false)
    setOpenClusters(false)
    setOpenInfoPage(false)
    setOpenPopper(false)
  }

  const onChangeFilterGroup = (e) => {
    setFilterGroup(e.target.value)
  }
  //----------------------




  //event select off Entity
  const onChangeEntity = (name) => {
    setEntity(name)
    setOpenEntity(false)
  }

  const handleClickOpenEntity = () => {
    setOpenEntity(!openEntity)
    setOpenGroup(false)
    setOpenClusters(false)
    setOpenInfoPage(false)
    setOpenPopper(false)
  }
  const onChangeFilterEntity = (e) => {
    setFilterEntity(e.target.value)
  }
  //----------------------
  const onChangeFilterInfopage = (e) => {
    setFilterInfopage(e.target.value)
  }


  //event select off InfoPage
  const onChangeInfoPage = (value) => {
    setInfoPage(value)
    setOpenInfoPage(false)
  }

  const handleClickOpenInfoPage = () => {
    setOpenInfoPage(!openInfoPage)
    setOpenGroup(false)
    setOpenClusters(false)
    setOpenEntity(false)
    setOpenPopper(false)
  }
  //----------------------



  const getChannelAssgin = (cluster) => {
    dataProvider('GET_ONE', `channels/findbycluster`, {
      id: cluster.id
    }).then(({ data }) => {
      var channels = []
      data.forEach(value => channels.push(value.id))
      setChannels(channels)
    }).catch(error => {
      console.error('Get list error:', error);
    });
  }

  //Onclick Add new Cluster
  const handelCreateCluster = () => {
    const body = {
      name: clusterName,
      entity: entity,
      group: group.name,
    }
    if (infoPage !== '')
      body.infopage = infoPage.id
    if (cluster !== '')
      body.channels = channels

    setLoading(true)
    dataProvider('CREATE', 'clusters', {
      data: body
    })
      .then((response) => {
        setLoading(false)
        handleClose()
        props.history.push('/Cluster/' + response.data.id)

      })
      .catch((error) => {
        setLoading(false)
        setError(translate(`pos.dashboard.createFailed`))
      })

  }
  //-------------------


  const getListInfoPage = () => {
    dataProvider('GET_LIST', "info-page-list", {
      filter: {
      },
      pagination: {
        page: 1,
        perPage: -1
      },
      sort: { field: 'name', order: 'ASC' },

    })
      .then(({ data }) => {
        setInfopages(data);
      })
      .catch(error => {
      })
  }


  React.useEffect(() => {
    if (open) {
      getListInfoPage()
      setCluster('')
      setEntity('')
      setGroup('')
      setInfoPage('')
      setClusterName('')
      setFilterCluster('')
      setFilterGroup('')
      setFilterEntity('')
      setdisabledEntity(false)
      setData(dataRecever)
      setError('')
      setOpenClusters(false)
      setOpenEntity(false)
      setOpenGroup(false)
      setOpenInfoPage(false)
      if (autoPickEnity != undefined)
        setEntity(autoPickEnity)
    }

  }, [open]);

  return (
    <Dialog open={open} aria-labelledby="form-dialog-title" scroll='paper'>
      <Box bgcolor='background.default' py={3}>
        <Box display='flex' justifyContent='flex-end' alignContent='center' mr={2}>
          <Typography style={{ margin: 'auto 8px auto 0' }} className={classes.textClose}>  {translate(`pos.dashboard.close`)}</Typography>
          <CloseButton onClick={handleClose} />
        </Box>
        <Box px={5}>
          <Box mb={2}>
            <Typography className={classes.titleCluster}>  {translate(`pos.dashboard.addCluster`)}</Typography>
          </Box>
          {
            error != "" && (
              <Box borderRadius='6px' my={1} width={500} bgcolor={bgColorError} py={1}>
                <Typography className={classes.TextValue} style={{ color: textColorError, margin: '1em' }}>{error}</Typography>
              </Box>
            )
          }

          <CustomTextFiled
            required
            id="filled-basic"
            label={translate(`pos.dashboard.name`)}
            value={clusterName}
            onChange={onChangeName}
            style={{ width: 500 }}
            endDom={
              <CustomPoper
                open={openPoper}
                anchorEl={anchorEl}
                handleClick={handleClickOpenPoper}
                handleClose={handleClosePoper}
                title={translate(`pos.dashboard.name`)}
                content={translate(`pos.dashboard.constent`)}
                icon={<b>?</b>}
              />}
          />
          <Box pt={1} pb={0} mt={1} width={500}>
            <SelectBox
              label={translate(`pos.dashboard.inheritFrom`)}
              header={(
                <Box className={classes.header} display='flex' mb="2px" p={1} bgcolor={colors.lightBlue['200']}>
                  <Box width='35%'><Typography className={classes.TextValue}>{translate(`pos.dashboard.cluster`)}</Typography></Box>
                  <Box width='33%'><Typography className={classes.TextValue}>{translate(`pos.dashboard.group`)}</Typography></Box>
                  <Box><Typography className={classes.TextValue}>{translate(`pos.dashboard.entity`)}</Typography></Box>
                </Box>
              )}
              filter={(
                <Box style={{ backgroundColor: "#ffffff" }} p={1} className={classes.boxBoder}>
                  <FilterInput open={openClusters} onChangeValue={onChangeFilterCluster} value={filterCluster} name={translate(`pos.dashboard.cluster`).toLowerCase()} />
                </Box>

              )}
              value={cluster == "" ? "" : cluster.name}
              open={openClusters}
              handleClick={handleClickOpenCluster}
            >

              {
                data.cluster.filter(value => value.name.toUpperCase().search(filterCluster.toUpperCase()) > -1).length === 0 ?
                  (
                    <Box display='flex' width='100%' justifyContent='center' my={1}>
                      <Typography className={classes.TextValue}>{translate(`pos.dashboard.notfound`)}</Typography>
                    </Box>
                  )
                  :
                  (
                    data.cluster.filter(value => value.name.toUpperCase().search(filterCluster.toUpperCase()) > -1).map((row, index) => (
                      <Box key={index} className={classes.boxBoder}>
                        <ListItem style={{ padding: '8px' }} button onClick={() => onChangeCluster(row)}>
                          <Box width='100%' display='flex'>
                            <Box width='35%'><Typography className={classes.TextValue}>{row.name}</Typography></Box>
                            <Box width='33%'><Typography className={classes.TextValue}>{row.group}</Typography></Box>
                            <Box><Typography className={classes.TextValue}>{row.entity}</Typography></Box>
                          </Box>
                        </ListItem>
                      </Box>
                    ))
                  )

              }

            </SelectBox>
          </Box>
          <Box pt={1} pb={0} mt={1} width={500}>
            <SelectBox
              required={true}
              label={translate(`pos.dashboard.selectOrCreateGroup`)}
              value={group == "" ? "" : group.name}
              open={openGroup}
              header={(
                <Box className={classes.header} display='flex' mb="2px" p={1} bgcolor={colors.lightBlue['200']}>

                  <Box width='40%'><Typography className={classes.TextValue}>{translate(`pos.dashboard.group`)}</Typography></Box>
                  <Box><Typography className={classes.TextValue}>{translate(`pos.dashboard.entity`)}</Typography></Box>
                </Box>
              )}
              filter={(
                <Box bgcolor="background.paper" p={1} className={classes.boxBoder}>
                  <FilterInput open={openGroup} onChangeValue={onChangeFilterGroup} value={filterGroup} name={translate(`pos.dashboard.group`).toLowerCase()} />
                </Box>

              )}
              CreateBox={
                <CreateInSelect
                  name={translate(`pos.dashboard.group`).toLowerCase()}
                  valueInput={valueNewGroup}
                  onChangValueInput={onChangNewValueGroup}
                  handelCreateNew={onCreateNewGroup}
                  openCreate={openCreateGroup}
                  handelCancelCreate={handelCancelCreateGroup}
                  clickOpenCreate={clickOpenCreateGroup}
                />}
              handleClick={handleClickOpenGroup}
            >

              {
                data.countResult.groups.filter(value => value.name.toUpperCase().search(filterGroup.toUpperCase()) > -1).length === 0 ?
                  (
                    <Box display='flex' width='100%' justifyContent='center' my={1}>
                      <Typography color='textPrimary' className={classes.TextValue}>{translate(`pos.dashboard.notfound`)}</Typography>
                    </Box>
                  )
                  :
                  (
                    data.countResult.groups.filter(value => value.name.toUpperCase().search(filterGroup.toUpperCase()) > -1).map((row, index) => (
                      <Box key={index} className={classes.boxBoder}>
                        <ListItem style={{ padding: '8px' }} button onClick={() => onChangeGroup(row)}>
                          <Box width='100%' display='flex'>
                            <Box width='40%'><Typography className={classes.TextValue}>{row.name}</Typography></Box>
                            <Box><Typography className={classes.TextValue}>{row.entity != "" && row.entity}</Typography></Box>
                          </Box>

                        </ListItem>
                      </Box>
                    ))
                  )

              }
            </SelectBox>
          </Box>
          <Box pt={1} pb={0} mt={1} width={500}>
            <SelectBox
              required={true}
              disabled={disabledEntity}
              label={translate(`pos.dashboard.selectOrCreateEntity`)}
              value={entity}
              open={openEntity}
              CreateBox={
                <CreateInSelect
                  name={translate(`pos.dashboard.entity`).toLowerCase()}
                  valueInput={valueNewEntity}
                  onChangValueInput={onChangNewValueEntity}
                  handelCreateNew={onCreateNewEntity}
                  openCreate={openCreateEntity}
                  handelCancelCreate={handelCancelCreateEntity}
                  clickOpenCreate={clickOpenCreateEntity}
                />

              }
              handleClick={handleClickOpenEntity}
            >
              <Box className={classes.boxBoder}>
                <ListItem style={{ padding: '8px' }} >
                  <FilterInput open={openEntity} onChangeValue={onChangeFilterEntity} value={filterEntity} name={translate(`pos.dashboard.entity`).toLowerCase()} />
                </ListItem>
              </Box>
              {
                data.countResult.entities.filter(value => value.name.toUpperCase().search(filterEntity.toUpperCase()) > -1).length === 0 ?
                  (
                    <Box display='flex' width='100%' justifyContent='center' my={1}>
                      <Typography className={classes.TextValue} >{translate(`pos.dashboard.notfound`)}</Typography>
                    </Box>

                  )
                  :
                  (
                    data.countResult.entities.filter(value => value.name.toUpperCase().search(filterEntity.toUpperCase()) > -1).map((row, index) => (
                      <Box key={index} className={classes.boxBoder}>
                        <ListItem style={{ padding: '8px' }} button onClick={() => onChangeEntity(row.name)}>
                          <Typography className={classes.TextValue}>{row.name}</Typography>
                        </ListItem>
                      </Box>
                    ))
                  )
              }
            </SelectBox>
          </Box>
          <Box pt={1} pb={0} mt={1} width={500}>
            <SelectBox
              label={translate(`pos.dashboard.selectInfoPage`)}
              value={infoPage === '' ? '' : infoPage.name}
              open={openInfoPage}
              handleClick={handleClickOpenInfoPage}

            >
              <Box className={classes.boxBoder}>
                <ListItem style={{ padding: '8px' }} >
                  <FilterInput open={openInfoPage} value={filterInfopage} onChangeValue={onChangeFilterInfopage} name={'info page'.toLowerCase()} />
                </ListItem>
              </Box>
              {
                infopages.filter(value => value.name.toUpperCase().search(filterInfopage.toUpperCase()) > -1).length === 0 ?
                  (
                    <Box display='flex' width='100%' justifyContent='center' my={1}>
                      <Typography className={classes.TextValue} >{translate(`pos.dashboard.notfound`)}</Typography>
                    </Box>

                  )
                  :
                  (
                    infopages.filter(value => value.name.toUpperCase().search(filterInfopage.toUpperCase()) > -1).map((row, index) => (
                      <Box key={index} className={classes.boxBoder}>
                        <ListItem style={{ padding: '8px' }} button onClick={() => onChangeInfoPage(row)}>
                          <Typography className={classes.TextValue}>{row.name}</Typography>
                        </ListItem>
                      </Box>
                    ))
                  )
              }
            </SelectBox>
          </Box>

          <Box display='flex' width='100%' justifyContent='flex-end' mt={3}>
            <Box display='flex' alignItems='flex-end' mr={3}>
             
                <TextButtons onClick={handleClose}/>
            </Box>
            <Button variant="contained" className={classes.btnCreateCluster} color='primary' onClick={handelCreateCluster} disabled={clusterName == "" || group == "" || entity == ""}>
              {loading ? (
                <CircularProgress
                  size={15}
                  thickness={2}
                  color='inherit'
                />
              ) :
                translate(`pos.dashboard.create`)
              }
            </Button>
          </Box>
        </Box>

      </Box>

    </Dialog>

  );
}
export default CreateClusterDialog